export default "__VITE_ASSET__CCZNRtGP__"